import { TLanguage } from 'contexts/app-context/types'
import { httpRequest, makeRequestURL } from 'common'

import { IGetEntityMenuResponse } from '../types'
import { getEntityMenuContentEndpoint } from '../utils'

const getEntityMenuContent = (language: TLanguage) => {
  const url = makeRequestURL(getEntityMenuContentEndpoint?.url ?? '', { language }, '.json')

  return httpRequest<IGetEntityMenuResponse>({
    ...getEntityMenuContentEndpoint,
    url,
  })
}

export { getEntityMenuContent }
